import "@arco-design/web-react/es/List/style";
import _List from "@arco-design/web-react/es/List";
import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Result/style";
import _Result from "@arco-design/web-react/es/Result";
import React from 'react';
import dayjs from 'dayjs';
import useLocale from '../../utils/useLocale';
import styles from './style/index.module.less';
import appHistory from '@/utils/history';
/**
 * 根据待办开始时间计算超时标签：
 * - 当天到达：青色，显示小时数
 * - 超过 3 天：金色
 * - 超过 10 天：红色，标记为超时
 */
function getOverdueTag(startTime) {
  if (!startTime) {
    return null;
  }
  const targetDate = dayjs(startTime);
  const currentDate = dayjs();
  const day = currentDate.diff(targetDate, 'days');
  let color = 'arcoblue';
  let text = `${day} 天`;
  if (day > 3 && day < 10) {
    color = 'gold';
  }
  if (day >= 10) {
    color = 'red';
    text = `超时 ${day} 天`;
  }
  if (day <= 0) {
    color = 'cyan';
    const hours = Math.max(currentDate.diff(targetDate, 'hours'), 0);
    text = hours ? `${hours} 小时` : '刚刚';
  }
  return {
    color,
    text
  };
}
function MessageList(props) {
  const t = useLocale();
  const {
    data
  } = props;
  function onItemClick(item) {
    props.onItemClick?.(item);
  }
  function onMoreClick() {
    props.onMoreClick?.();
    appHistory.push('/todo/task');
  }
  return /*#__PURE__*/React.createElement(_List, {
    noDataElement: /*#__PURE__*/React.createElement(_Result, {
      status: "404",
      subTitle: t['message.empty.tips']
    }),
    footer: data.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: styles.footer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['footer-item']
    }, /*#__PURE__*/React.createElement(_Button, {
      type: "text",
      size: "small",
      onClick: () => onMoreClick()
    }, t['message.seeMore'])))
  }, data.map(item => {
    const tag = getOverdueTag(item.startTime);
    return /*#__PURE__*/React.createElement(_List.Item, {
      key: item.id,
      actionLayout: "vertical"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        cursor: 'pointer'
      },
      onClick: () => {
        onItemClick(item);
      }
    }, /*#__PURE__*/React.createElement(_List.Item.Meta, {
      title: /*#__PURE__*/React.createElement("div", {
        className: styles['message-title']
      }, /*#__PURE__*/React.createElement(_Space, {
        size: 4
      }, /*#__PURE__*/React.createElement("span", null, item.subTitle || '-')), tag ? /*#__PURE__*/React.createElement(_Tag, {
        color: tag.color
      }, tag.text) : null),
      description: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Typography.Paragraph, {
        style: {
          marginBottom: 0
        },
        ellipsis: true
      }, item.title))
    })));
  }));
}
export default MessageList;